import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Population Density Calculator - Calculate Population Density Based on Population and Area';
const DESCRIPTION = 'The Population Density Calculator calculates population density based on the entered population and area.';
const KEYWORDS = 'Population Density, Calculate Population Density, Population Density Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/population-density';
function Calculator() {
    const [population, setPopulation] = useState('');
    const [area, setArea] = useState('');
    const [density, setDensity] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!population || !area) {
            setError('Please enter valid population and area values');
            setDensity('');
            return;
        }
        const populationValue = parseFloat(population);
        const areaValue = parseFloat(area);
        if (isNaN(populationValue) || isNaN(areaValue) || populationValue < 0 || areaValue <= 0) {
            setError('Please enter valid and positive values for population and area');
            setDensity('');
            return;
        }
        const populationDensity = populationValue / areaValue;
        setDensity(populationDensity.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                    <h2 style={{fontSize:'18px'}}>How to Calculate Population Density</h2>
                                        <p>
                                            If you want to know the population density of an area, country, or city, you first need to count the population in that area and determine its area. Then, you can calculate the population density by dividing the population by the area.
                                        </p>
                                        <p>
                                            Population Density = (Population / Area)
                                        </p>
                                        <p>
                                            You can use this calculator to calculate population density based on the entered values.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE}</h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Population</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Population"
                                                        value={population}
                                                        onChange={(e) => setPopulation(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Area (Square Meters)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Area"
                                                        value={area}
                                                        onChange={(e) => setArea(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Population Density
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {density !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Population Density: {density} people/sq. m
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
